var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharmRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84375 13.4062L3.09375 12.7188C3.09375 12.7188 3.09375 10.6562 3.78125 8.59375C4.46875 6.53125 9.28125 6.53125 9.28125 6.53125M5.84375 13.4062L8.59375 16.1562M5.84375 13.4062C5.84375 13.4062 8.59375 6.53125 12.0312 4.46875C15.4688 2.40625 19.5938 2.40625 19.5938 2.40625C19.5938 2.40625 19.5938 6.53125 17.5312 9.96875C15.4688 13.4062 8.59375 16.1562 8.59375 16.1562M8.59375 16.1562L9.28125 18.9062C9.28125 18.9062 11.3438 18.9062 13.4062 18.2188C15.4688 17.5312 15.4688 12.7188 15.4688 12.7188",
    stroke: "#232B35",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 19.5938L5.15625 18.2188L3.78125 16.8438L2.40625 19.5938Z",
    stroke: "#232B35",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 8.59375C14.4734 8.59375 14.7812 8.28595 14.7812 7.90625C14.7812 7.52655 14.4734 7.21875 14.0938 7.21875C13.7141 7.21875 13.4062 7.52655 13.4062 7.90625C13.4062 8.28595 13.7141 8.59375 14.0938 8.59375Z",
    stroke: "#232B35",
    strokeWidth: 1.81,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharmRocket);
export default __webpack_public_path__ + "static/media/charm-rocket.7af8360304a8b56231dece78e6b4ef3c.svg";
export { ForwardRef as ReactComponent };